module.exports = __webpack_public_path__ + "h5/img/duan.781dce27.jpg";